import { useUserStore } from '@/stores/modules/user'
import type { SkillQuality } from '@/types/skill'
import { formatNumber } from '@/utils'
import { skillQualityDamageMag } from '.'

export const passiveCollection: Record<number, { desc: (skillId: number, data: any, quality: SkillQuality) => string }> = {
  30001: {
    desc: (skillId, data, quality) =>
      `每次<span class="info">攻击</span>恢复 <span class="grow">${formatNumber(
        data.mp * getAddtion(skillId) * skillQualityDamageMag[quality],
        1,
      )}</span><span class="mp">魔法值</span>`,
  },
  30002: {
    desc: (skillId, data, quality) =>
      `<span class="info">暴击</span>时恢复 <span class="grow">${formatNumber(
        data.mp * getAddtion(skillId) * skillQualityDamageMag[quality],
        1,
      )}</span><span class="mp">魔法值</span>`,
  },
  30003: {
    desc: (skillId, data, quality) =>
      `增加 <span class="grow">${formatNumber(
        data.mpRegen * getAddtion(skillId) * skillQualityDamageMag[quality],
        1,
      )}</span><span class="mp">魔法回复</span>（战斗时生效）`,
  },
  30004: {
    desc: (skillId, data, quality) =>
      `增加<span class="info">破防</span> <span class="grow">${formatNumber(
        data.multiplier * getAddtion(skillId) * skillQualityDamageMag[quality],
        2,
      )}%</span>的<span class="mp">魔法回复</span>（战斗时生效）`,
  },
  30005: {
    desc: (skillId, data, quality) =>
      `每 <span class="grow">${data.count}</span>次<span class="mp">技能攻击</span>，额外造成 <span class="grow">${formatNumber(
        data.damage * getAddtion(skillId) * useUserStore().getSkillAtkAddtion() * skillQualityDamageMag[quality],
        1,
      )}</span>（受攻击力加成）的🌪️风属性伤害`,
  },
  30006: {
    desc: (skillId, data, quality) =>
      `每 <span class="grow">${data.count}</span>次<span class="shrink">暴击攻击</span>，额外造成 <span class="grow">${formatNumber(
        data.damage * getAddtion(skillId) * useUserStore().getSkillAtkAddtion() * skillQualityDamageMag[quality],
        1,
      )}</span>（受攻击力加成）的🔥火属性伤害`,
  },
  30007: {
    desc: (skillId, data, quality) =>
      `每 <span class="grow">${data.count}</span>次<span class="info">攻击</span>，额外造成 <span class="grow">${formatNumber(
        data.damage * getAddtion(skillId) * useUserStore().getSkillAtkAddtion() * skillQualityDamageMag[quality],
        1,
      )}</span>（受攻击力加成）的💧水属性伤害`,
  },
  30008: {
    desc: (skillId, data, quality) =>
      `每 <span class="grow">${data.count}</span>次<span class="equipped">普通攻击</span>，额外造成 <span class="grow">${formatNumber(
        data.damage * getAddtion(skillId) * useUserStore().getSkillAtkAddtion() * skillQualityDamageMag[quality],
        1,
      )}</span>（受攻击力加成）的🌱土属性伤害`,
  },
  50009: {
    desc: (skillId, data, quality) =>
      `技能伤害加成<span class="shrink">减半</span>，冷却缩减 + <span class="grow">${formatNumber(
        data.value * getAddtion(skillId) * skillQualityDamageMag[quality],
        1,
      )}`,
  },
  50010: {
    desc: (skillId, data, quality) =>
      `魔法消耗<span class="shrink">翻倍</span>，技能伤害 + <span class="grow">${formatNumber(
        data.multiplier * getAddtion(skillId) * skillQualityDamageMag[quality],
        1,
      )}%</span>`,
  },
  50011: {
    desc: (skillId, data, quality) =>
      `魔法回复<span class="shrink">减半</span>，普攻攻击伤害 + <span class="grow">${formatNumber(
        data.multiplier * getAddtion(skillId) * skillQualityDamageMag[quality],
        1,
      )}%</span>`,
  },
  50012: {
    desc: (skillId, data, quality) =>
      `技能伤害加成 - <span class="shrink">50%</span>，普攻攻击伤害 + <span class="grow">${formatNumber(
        data.multiplier * getAddtion(skillId) * skillQualityDamageMag[quality],
        1,
      )}%</span>`,
  },
  40009: {
    desc: (skillId, data, quality) =>
      `怪物血量低于 <span class="grow">${formatNumber(
        data.hpPercent * getAddtion(skillId) * skillQualityDamageMag[quality],
        1,
      )}%</span> 时，魔法回复值<span class="grow">翻倍</span>`,
  },
  40010: {
    desc: (skillId, data, quality) =>
      `怪物血量低于 <span class="grow">${formatNumber(
        data.hpPercent * getAddtion(skillId) * skillQualityDamageMag[quality],
        1,
      )}%</span> 时，必定暴击`,
  },
  40011: {
    desc: (skillId, data, quality) =>
      `怪物血量低于 <span class="grow">${formatNumber(
        data.hpPercent * getAddtion(skillId) * skillQualityDamageMag[quality],
        1,
      )}%</span> 时，必定命中`,
  },
  40012: {
    desc: (skillId, data, quality) =>
      `怪物血量低于 <span class="grow">${formatNumber(
        data.hpPercent * getAddtion(skillId) * skillQualityDamageMag[quality],
        1,
      )}%</span> 时，无视防御`,
  },
  40013: {
    desc: (skillId, data, quality) =>
      `<span class="info">未暴击</span>时，伤害 + <span class="grow">${formatNumber(
        data.multiplier * getAddtion(skillId) * skillQualityDamageMag[quality],
        1,
      )}%</span>；反之伤害 - <span class="shrink">50%</span>`,
  },
  40014: {
    desc: (skillId, data, quality) =>
      `额外造成敌方<span class="info">抗暴值</span> <span class="grow">${formatNumber(
        data.mag * getAddtion(skillId) * skillQualityDamageMag[quality],
        2,
      )}</span> 倍的伤害`,
  },
  40015: {
    desc: (skillId, data, quality) =>
      `获得敌方<span class="info">闪避值</span> <span class="grow">${formatNumber(
        data.mag * getAddtion(skillId) * skillQualityDamageMag[quality],
        2,
      )}</span> 倍的破防`,
  },
  40016: {
    desc: (skillId, data, quality) =>
      `<span class="grow">${formatNumber(data.rate * getAddtion(skillId) * skillQualityDamageMag[quality], 1)}%</span> 概率，将所有伤害转为<span class="real-damage">真实伤害</span>`,
  },
}

function getAddtion(skillId: number) {
  const userStore = useUserStore()
  return userStore.getSkillLevelAddtion(skillId)
}
